<div *ngIf="(subscription?.subscriptionId === userSubscriptionIds.TRIAL || subscription?.subscriptionId === userSubscriptionIds.TRIAL_OPTIMIZER)
 && _user?.workspaces?.length <= 1"
     class="db-main-header-content" dbMainHeaderContent>
  <div class="header-title">
    <div class="texts">
      <span class="add-website-starter__header-title db-center"><img src="assets/images/logos/10web_name_logo_dark.svg" alt=""></span>
    </div>
  </div>
</div>


<div class="db-add-website" *ngIf="(exceededDomains$ | async) && subscription?.subscriptionId !== userSubscriptionIds.TRIAL && subscription?.subscriptionId !== userSubscriptionIds.TRIAL_OPTIMIZER">
  <db-domains-exceeded [upgradeAvailable]="upgradeAvailable" [showImage]="true" [buttonColor]="'success'" [title]="'text_domainsExceededTitle' | dbText" [description]="'text_domainsExceededDescription' | dbText"></db-domains-exceeded>
  <db-loading-screen class="sl-autoinstall-website-loader" [ngClass]="{'hidden':!loading}" [pageBlocker]="true"></db-loading-screen>
</div>
<db-loading-screen [hidden]="!fromSandbox" [loadingMessage]="'Please wait while PayPal processing finished.'" [pageBlocker]="true" [fullSize]="true"></db-loading-screen>

<db-connect-only *ngIf="!(exceededDomains$ | async) && subscription?.subscriptionId !== userSubscriptionIds.TRIAL
&& subscription?.subscriptionId !== userSubscriptionIds.TRIAL_OPTIMIZER" [managerLink]="managerLink"
                 [premiumPlugin]="premiumPlugin" (download)="downloadManagerPluginEvent()" (signOut)="signOut()"></db-connect-only>

<db-create-migrate *ngIf="subscription?.subscriptionId === userSubscriptionIds.TRIAL
&& signUpForAnswers?.Reason?.id !== typeFormAnswers.BUILD_NEW_WEBSITE
&& signUpForAnswers?.Reason?.id !== typeFormAnswers.OPTIMIZE_MY_WEBSITE || allowCreation"
                   [managerLink]="managerLink" [productId]="subscription?.product_id"
                   (download)="downloadManagerPluginEvent()" (openDialog)="openDialog()"></db-create-migrate>

<db-migration-only *ngIf="subscription?.subscriptionId === userSubscriptionIds.TRIAL && !allowCreation
&& signUpForAnswers?.Reason && signUpForAnswers?.Reason?.id === typeFormAnswers.OPTIMIZE_MY_WEBSITE"
                   [managerLink]="managerLink" [user]="_user" [newOnboarding]="false" (download)="downloadManagerPluginEvent()"></db-migration-only>


<!--<div *ngIf="subscription?.subscriptionId === userSubscriptionIds.TRIAL && signUpForAnswers?.Reason && signUpForAnswers?.Reason?.id === typeFormAnswers.OPTIMIZE_MY_WEBSITE"-->
<!--     class="db-add-website__optimization-flow-wrap" dbCustomScrollbar>-->
<!--  <div>-->
<!--    <db-optimization-preview></db-optimization-preview>-->
<!--  </div>-->
<!--</div>-->

<div class="db-add-website__create-website" *ngIf="subscription?.subscriptionId === userSubscriptionIds.TRIAL
&& !allowCreation && signUpForAnswers?.Reason && signUpForAnswers?.Reason?.id === typeFormAnswers.BUILD_NEW_WEBSITE">
  <db-website-install-trial-flow  (height)="'400px'" [upgradeAvailable]="upgradeAvailable" [insidePageContent]="true" [currentSubscription]="subscription" [showBackButton]="false" (showComponent)="null" [userId]="_user.id" [hostingsLimit]="hostingsLimit"></db-website-install-trial-flow>
</div>
